module.exports = __webpack_public_path__ + "media/images/flags/1x1/qat-40fb032b39ba22519cc6a5a96bae7135.svg";